import { createUriFiles } from 'owa-attachment-file-types';
import { ClientAttachmentId, ClientItemId } from 'owa-client-ids';
import { ComposeViewState } from 'owa-mail-compose-store';
import { findComposePlugins } from 'owa-mail-compose-actions/lib/plugins/ComposePlugins';
import createAttachments from 'owa-mail-compose-actions/lib/utils/createAttachments';
import {
    infoBarAddHandler,
    infoBarRemoveHandler,
} from 'owa-mail-compose-actions/lib/utils/infoBarHandlers';
import { onAttachmentCreated } from 'owa-attachment-well-data';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';

export default function addFile(
    viewState: ComposeViewState,
    attachmentName: string,
    uri: string,
    isInline: boolean
): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        let hasProcessed = false;
        const handler = infoBarAddHandler(viewState);

        const attachmentErrorHandler = (canceled: boolean) => {
            if (!hasProcessed) {
                hasProcessed = true;
                reject({ errorType: 'UploadError' });
            }
        };

        const onFinish = (attachmentId: ClientAttachmentId) => {
            if (!hasProcessed) {
                hasProcessed = true;
                resolve(attachmentId.Id);
            }
        };

        try {
            const file = createUriFiles([{ name: attachmentName, url: uri }]);
            const composePlugins = findComposePlugins(viewState);
            const inlineImagePlugin = composePlugins.inlineImage;
            const isPlainText = viewState.bodyType != 'HTML';
            const processInlineImageBeforeUpload = isPlainText
                ? null
                : inlineImagePlugin.processInlineImageBeforeUpload.bind(inlineImagePlugin);

            createAttachments(
                file,
                viewState,
                {
                    isInline,
                    isHiddenInline: true,
                    shouldShare: false,
                },
                processInlineImageBeforeUpload,
                handler,
                infoBarRemoveHandler(viewState),
                onFinish,
                onAttachmentCreatedCallback,
                attachmentErrorHandler
            );
        } catch (err) {
            reject({ errorType: 'UploadError' });
        }
    });
}

export const onAttachmentCreatedCallback = (
    parentItemId: ClientItemId,
    attachmentId: ClientAttachmentId,
    attachment: AttachmentType
) => {
    onAttachmentCreated(parentItemId, attachmentId, attachment);
};
